import { render, staticRenderFns } from "./PscInspectionHistory.vue?vue&type=template&id=0811c734&scoped=true&"
import script from "./PscInspectionHistory.vue?vue&type=script&lang=js&"
export * from "./PscInspectionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811c734",
  null
  
)

export default component.exports